import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import GalleryGrid from '../../../../core/components/GalleryGrid';
import ImageGallery from '../../../../core/components/ImageGallery';
import Image from '../../../../core/components/Uploaders/Image';
import { GalleryItems, GalleryThumbnails } from './constants';
const GalleryContent = ({ className, items: itemsRaw = [], loading = false, loadingMore = false, showCounter = true, truncate = true, thumbnailRenderers = GalleryThumbnails, }) => {
    const [index, setIndex] = useState(null);
    const items = useMemo(() => {
        if (loading) {
            return new Array(6).fill({ skeleton: true });
        }
        if (loadingMore) {
            return [...itemsRaw, ...new Array(6).fill({ skeleton: true })];
        }
        return itemsRaw;
    }, [itemsRaw, loading, loadingMore]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GalleryGrid, { className: className, items: items, truncate: truncate, onClick: (i) => {
                if (!items[i].skeleton) {
                    setIndex(i);
                }
            } }, (item) => {
            if (item.skeleton) {
                return React.createElement(Image, { loading: true });
            }
            const Component = Object.assign(Object.assign({}, GalleryThumbnails), thumbnailRenderers)[item.dataType];
            if (!Component) {
                return null;
            }
            return React.createElement(Component, { item: item });
        }),
        index !== null && (React.createElement(ImageGallery, { index: index, items: itemsRaw, showCounter: showCounter, onChange: setIndex }, (item) => {
            if (!item) {
                return null;
            }
            const Component = GalleryItems[item.dataType];
            if (!Component) {
                return null;
            }
            return React.createElement(Component, { item: item });
        }))));
};
GalleryContent.propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    loadingMore: PropTypes.bool,
    showCounter: PropTypes.bool,
    thumbnailRenderers: PropTypes.object,
    truncate: PropTypes.bool,
};
export default GalleryContent;
//# sourceMappingURL=index.js.map